import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { Router } from '@angular/router';
import { ApiService } from '@core/providers/http';
import { BolseiroService } from '@app/features-modules/gestao-bolseiros/components/api/services';
import { NivelAcademicoPipe } from '@app/features-modules/gestao-bolseiros/pipes/nivel-academico.pipe';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-card-person-bolseiros',
  templateUrl: './card-person-bolseiros.component.html',
  styleUrls: ['./card-person-bolseiros.component.scss'],
  standalone: true,
  imports: [CommonModule, TagModule, NivelAcademicoPipe, AvatarModule],
  providers: [ApiService, BolseiroService],
})
export class CardPersonBolseirosComponent {
  @Input() bolseiro: any;
  private bolseiroService = inject(BolseiroService);
  private router = inject(Router);
  imageError = false;

  get foto() {
    return this.bolseiro?.foto || this.bolseiro?.photo || this.bolseiro?.avatar || null;
  }

  getInitials(name?: string | null): string {
    return getInitials(name);
  }
  // [routerLink]="['detalhe-bolseiro', bolseiro.id]"

  Show = false;

  ShowDetais(event: Event) {
    event.stopPropagation();
    this.Show = !this.Show;
  }

  get nome() {
    return this.bolseiro?.nome || '';
  }

  get idade() {
    return this.bolseiro?.idade || 0;
  }

  get estadoCivil() {
    return this.bolseiro?.estadoCivil;
  }

  get genero() {
    return this.bolseiro?.genero;
  }

  get email() {
    return this.bolseiro?.email || '';
  }

  get nacionalidade() {
    return this.bolseiro?.nacionalidade || '';
  }

  get nivelAcademico() {
    return this.bolseiro?.nivelAcademico;
  }

  get estado() {
    return this.bolseiro?.isActive ? 'Activo' : 'Inactivo';
  }

  get severity() {
    return this.estado == 'Activo' ? 'success' : 'danger';
  }

  routerLink() {
    this.router.navigate([
      '/gestao-bolseiros/bolseiros/detalhe-bolseiro/',
      this.bolseiro.id,
    ]);
  }

  public gerarComprovativo() {
    let body = {
      tipoDocumento: 5,
      estadoDocumento: 0,
      utilizadorID: "string",
      dados: {
        bolseiroID: this.bolseiro.id,
        estado: "Enquadrada",
        estadoInterno: "Externo",
        grauAcademico: "string"
      }
    }
    this.bolseiroService.gerarFichaCadastro(body).subscribe((response) => {
      const url = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Ficha de cadastro.pdf';
      document.body.appendChild(a);
      a.click();
      // window.URL.revokeObjectURL(url);
      // document.body.removeChild(a);
      console.log('Ficha de cadastro gerada com sucesso');
      // this.configService.showSuccess('Nota de encomenda gerada com sucesso');
      // this.listarEncomendas();
    });
  }

  /* public gerarComprovativo() {
    this.bolseiroService.exportFichaCadastro().subscribe((response) => {
      const url = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Ficha de cadastro.pdf';
      document.body.appendChild(a);
      a.click();
      // window.URL.revokeObjectURL(url);
      // document.body.removeChild(a);
      console.log('Ficha de cadastro gerada com sucesso');
      // this.configService.showSuccess('Nota de encomenda gerada com sucesso');
      // this.listarEncomendas();
    });
  } */

  public gerarOficio(id: number) {
    this.bolseiroService.exportOficio(id).subscribe((response) => {
      const url = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Oficio.pdf';
      document.body.appendChild(a);
      a.click();
      // window.URL.revokeObjectURL(url);
      // document.body.removeChild(a);
      console.log('Ofício gerado com sucesso');
      // this.configService.showSuccess('Ofício gerado com sucesso');
      // this.listarEncomendas();
    });
  }

  GotoAuxForm(){
    this.router.navigate(['/gestao-bolseiros/auxilio-formacao/cadastrar-auxilio-formacao/'+ this.bolseiro.numeroBI ]);
  }
}
